export default function () {
    return (
        <svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7369_82516)">
                <path
                    d="M22 11.4995C22.1713 11.5132 23.3361 11.4823 23.5 11.4995C26.5 11.4995 28 13.9844 28 15.9995C28 16.9995 27.5 18.9995 25.9338 20.1732C25.762 20.2839 24.6863 20.3927 24.5 20.4995"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path
                    d="M9.76562 11.5C8.87674 11.5 7.5434 11.5 5.76562 11.5C6.04259 12.1079 7.30012 14.8305 7.99428 15"
                    stroke="black"
                    strokeWidth="1.2"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16 3.5C16.2762 3.5 16.5262 3.61194 16.7071 3.79293C16.8881 3.97388 17 4.22387 17 4.5C17 4.77613 16.8881 5.02612 16.7071 5.20707C16.5262 5.38806 16.2762 5.5 16 5.5C15.7238 5.5 15.4738 5.38806 15.2929 5.20707C15.1119 5.02612 15 4.77613 15 4.5C15 4.22387 15.1119 3.97388 15.2929 3.79293C15.4738 3.61194 15.7238 3.5 16 3.5Z"
                    stroke="black"
                    strokeWidth="0.96"
                />
                <path
                    d="M24.8506 26.432C24.8627 26.3083 24.8742 26.1841 24.8849 26.0595C24.9606 25.1795 25 24.2767 25 23.3567C25 18.9849 24.1114 15.0018 22.6541 12.0064C21.0081 8.62319 18.6364 6.5 16 6.5C13.3528 6.5 10.9725 8.64064 9.32568 12.0481C7.88036 15.0387 7 19.0051 7 23.3567C7 24.2949 7.04093 25.2152 7.11962 26.1118C7.13102 26.2417 7.14322 26.3711 7.1562 26.5"
                    stroke="black"
                    strokeWidth="1.2"
                />
                <path d="M10 11.5H23" stroke="black" strokeWidth="1.2" />
                <path d="M15 23.5H17" stroke="black" strokeWidth="1.2" strokeLinecap="round" />
                <rect x="5.6" y="26.1" width="20.8" height="2.8" rx="1.4" stroke="black" strokeWidth="1.2" />
            </g>
            <defs>
                <clipPath id="clip0_7369_82516">
                    <rect width="32" height="32" fill="white" transform="translate(0 0.5)" />
                </clipPath>
            </defs>
        </svg>
    );
}
